import React from 'react'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import moment from 'moment'
import { Placement } from 'react-bootstrap/esm/types'
import styled, { css } from 'styled-components'
import PixelDiv from '../pixel-div/pixel-div'
import PixelText from '../pixel-text/pixel-text'
import { colors } from '../styleGuide'

export interface PixelDateProps {
  className: string
  value: string
  format?: string
  size?: string
  style?: React.CSSProperties
  popoverPlacement?: Placement
  showFullDatePopover?: boolean
  color?: string
}
const StyledDate = styled.span<{
  $dashed?: boolean
  color?: string
  size?: string
}>`
  ${(props) =>
    props.size &&
    css`
      font-size: ${props.size} !important;
    `}
  border-bottom: ${(props) => (props.$dashed ? '1px dashed' : '')};
  cursor: ${(props) => (props.$dashed ? 'pointer' : '')};
  color: ${(props) => (props.color ? props.color : colors.black)};
  font-weight: 400;
  line-height: 100%;
`
export const PixelDate = React.forwardRef<HTMLDivElement, PixelDateProps>(
  (
    {
      className,
      value = new Date(),
      format,
      size,
      style,
      popoverPlacement = 'top',
      showFullDatePopover = true,
      color,
      ...rest
    },
    _ref,
  ) => {
    const formats: { [key: string]: string } = {
      pixelStandard: 'll',
      dateWithTime: 'll, h:mm:ss A',
    }
    const popoverLeft = (
      <StyledPopover id="popover-trigger-hover-focus" title="Popover">
        <PixelText
          customColor={color ? color : colors.black}
          copyToClipboard
          copiedText={`${new Date(value)}`}
        >
          {`${new Date(value)}`}
        </PixelText>
      </StyledPopover>
    )
    const PixelDate = (
      <StyledDate
        $dashed={showFullDatePopover}
        className={className}
        color={color}
        style={style}
        size={size}
        {...rest}
      >
        {moment(value).format(
          format ? formats[format] || format : 'DD/MM/YYYY',
        )}
      </StyledDate>
    )

    return (
      <PixelDiv>
        {showFullDatePopover ? (
          <OverlayTrigger
            trigger={['click', 'focus']}
            rootClose
            placement={popoverPlacement}
            overlay={popoverLeft}
          >
            {PixelDate}
          </OverlayTrigger>
        ) : (
          PixelDate
        )}
      </PixelDiv>
    )
  },
)
export default PixelDate
const StyledPopover = styled(Popover)`
  padding: 4px;
  box-shadow: rgba(0, 0, 0, 0.2) 2px 3px 10px;
`
